import React from 'react';

import LegalPolicyPage from './LegalPolicyPage';

interface GDPRCompliancePageProps {
  onNavigate: (view: string) => void;
}

const GDPRCompliancePage: React.FC<GDPRCompliancePageProps> = ({ onNavigate }) => (
  <LegalPolicyPage policyId="gdpr" onNavigate={onNavigate} />
);

export default GDPRCompliancePage;
